import { getURLParameterBykey } from 'yoda-core-components/lib/helpers/Utils/Utils';
import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import isApiSuccess from '../RestClient/isApiSuccess';

const getInventoryMock = (id) => ({
    id,
    atp: true,
    quality: 'AH',
});

const getlotPriceMock = (id) => ({
    id,
    couponInfo: [],
    manufacturerAdvertised: true,
    fpacDisplayIndicator: false,
    hybridIndicator: false,
    marketingLabel: '',
    amounts: [
        {
            max: 0,
            min: 0,
            type: 'original',
            minPercentOff: 0,
            maxPercentOff: 0,
        },
        {
            max: 0,
            min: 0,
            type: 'default',
            minPercentOff: 0,
            maxPercentOff: 0,
        },
    ],
});

const getAnalyticsMock = () => ({
    productCurrentSellingPrice: '',
    productListPrice: '',
    productPricingCadence: '',
    productMarketingLabel: '',
    couponCode: '',
    couponEligible: '',
    couponType: '',
    couponDiscount: '',
    couponAmount: '',
    couponApplyMethod: '',
});

const getInventoryFallBack = ({ lots }) => {
    const lotData = [];
    const inventoryData = [];

    lots.forEach(({ id: lotId, items }) => {
        lotData.push(getlotPriceMock(lotId));
        items.forEach(({ id: itemId }) => {
            inventoryData.push(getInventoryMock(itemId));
        });
    });

    return {
        analyticsPrice: getAnalyticsMock(),
        inventory: inventoryData,
        myAlertIndicator: false,
        prices: {},
        lotPrice: {
            data: lotData,
            href: '',
        },
    };
};

const getBundleInventoryFallBack = ({ products }) => {
    const inventoryData = [];
    const productsPrice = [];

    products.forEach(({ product: { id: ppId, lots } }) => {
        const lotData = [];
        lots.forEach(({ id: lotId, items }) => {
            lotData.push(getlotPriceMock(lotId));
            items.forEach(({ id: itemId }) => {
                inventoryData.push(getInventoryMock(itemId));
            });
        });
        productsPrice.push({
            id: ppId,
            lotPrice: {
                data: lotData,
                href: '',
            },
        });
    });

    return {
        productsPrice,
        analyticsPrice: getAnalyticsMock(),
        inventory: inventoryData,
        bundleprice: {
            manufacturerAdvertised: true,
            fpacDisplayIndicator: false,
            hybridIndicator: false,
            marketingLabel: '',
            amounts: [
                {
                    max: 0,
                    min: 0,
                    type: 'original',
                    minPercentOff: 0,
                    maxPercentOff: 0,
                },
                {
                    max: 0,
                    min: 0,
                    type: 'default',
                    minPercentOff: 0,
                    maxPercentOff: 0,
                },
            ],
        },
    };
};

const isRequestFromGoogleSource = () => {
    if (!__SERVER__) {
        const utmSourceParam = getURLParameterBykey('utm_source', window?.location?.search);
        return utmSourceParam === 'google';
    }
    return false;
};

/* istanbul ignore next */
const isRequestFromDisableLoc = () => {
    if (!__SERVER__) {
        const disableLocParam = getURLParameterBykey('disableLoc', window?.location?.search);
        return disableLocParam;
    }
    return false;
};

export const getInventory = (payload, featureFlags, productDetails = {}) => {
    const { myAlertsNew, virtualAPI, myAlertsMiniPDP } = featureFlags;
    const context = RestClient.getContext();
    const requestParams = {};

    if (payload.storeID) {
        requestParams.stores = payload.storeID;
    }

    if (payload.regionId) {
        requestParams.regionId = payload.regionId;
    }

    if (myAlertsNew || myAlertsMiniPDP) {
        requestParams.deliveryAvailabilityCheckRequired = false;
    }
    /* istanbul ignore next */
    const { url } = payload;

    /* istanbul ignore next */
    return RestClient.get({
        url,
        apiHost: apiHosts.browse,
        virtual: virtualAPI,
        credentials: 'include',
        params: {
            ...requestParams,
            ...(featureFlags.enableLocalization && { GPA: isRequestFromGoogleSource() }),
            ...(featureFlags.enableLocalization && { geoZip: payload.geoZip }),
            ...(isRequestFromDisableLoc() && { disableLoc: isRequestFromDisableLoc() }),
        },
        excludeVersion: true,
        hostname: context && context.hostname,
        XForwardedChannelHeader: `${payload.deviceSize}`, // todo this
    })
        .then(
            ({ data, status }) =>
                (isApiSuccess(status) && data) || getInventoryFallBack(productDetails)
        )
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};

export const getBundleInventory = (payload, featureFlags = {}, productDetails = {}) => {
    const context = RestClient.getContext();
    /* istanbul ignore next */
    const storeID = payload.storeID !== '' ? `?stores=${payload.storeID}` : '';
    /* istanbul ignore next */
    const url = `${payload.url}${storeID}`;
    const { enableLocalization = false } = featureFlags;
    /* istanbul ignore next */
    return RestClient.get({
        url,
        apiHost: apiHosts.browse,
        credentials: 'include',
        params: {
            ...(enableLocalization && { GPA: isRequestFromGoogleSource() }),
            ...(enableLocalization && { geoZip: payload.geoZip }),
            ...(isRequestFromDisableLoc() && { disableLoc: isRequestFromDisableLoc() }),
        },
        excludeVersion: true,
        hostname: context && context.hostname,
        XForwardedChannelHeader: `${payload.deviceSize}`, // todo this
    })
        .then(
            ({ data, status }) =>
                (isApiSuccess(status) && data) || getBundleInventoryFallBack(productDetails)
        )
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
